import { useEffect, useState } from "react";

import Loading from "@/app/loading";
import { Button, Modal, Table } from "react-bootstrap";

import api from "@/lib/api";

type SurveyModalProps = {
  surveyId: number | undefined;
  showSurveyModal: boolean;
  handleCloseSurveyModal: () => void;
  handleOpenModuleModal: (moduleId: number) => void;
};

type SurveyModalData = {
  overview: {
    study_title: string;
    title: string;
  };
  modules: {
    value: number;
    label: string;
  }[];
};

export async function getSurveyModalData(survey_id: number) {
  try {
    const response = await api.get<SurveyModalData>(`/srv/survey/${survey_id}`);
    return response;
  } catch (error) {
    console.error("Error fetching survey data:", error);
    throw error;
  }
}

export default function SurveyModal({
  showSurveyModal,
  surveyId,
  handleCloseSurveyModal,
  handleOpenModuleModal,
}: SurveyModalProps) {
  const [surveyData, setSurveyData] = useState<SurveyModalData>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (!surveyId) {
        setSurveyData(undefined);
        return;
      }

      setLoading(true);
      setError(false);
      try {
        const response = await getSurveyModalData(surveyId);
        setSurveyData(response);
      } catch (err) {
        console.error("Failed to fetch survey data:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [showSurveyModal, surveyId]);

  return (
    <Modal show={showSurveyModal} onHide={handleCloseSurveyModal} size="xl" aria-labelledby="srv-item-modal">
      <Modal.Header closeButton>
        <Modal.Title className="g2-text-grey">
          {surveyData?.overview?.study_title} {surveyData?.overview?.title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {loading ? (
          <Loading />
        ) : error || !surveyId ? (
          <div className="alert alert-warning" role="alert">
            Oops! something went wrong.
          </div>
        ) : (
          <Table className="table table-striped table-hover table-bordered" width="100%">
            <thead className="table-dark">
              <tr>
                <th>MODULES ({surveyData?.modules?.length || 0})</th>
              </tr>
            </thead>
            <tbody>
              {surveyData?.modules?.map((item, index) => (
                <tr key={index}>
                  <td>
                    <span
                      className="g2-link-blue"
                      onClick={() => {
                        handleOpenModuleModal(item.value);
                        handleCloseSurveyModal();
                      }}
                    >
                      {item.label}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseSurveyModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
